export function setFilterPrefixes(prefix: string, filter: any) {
  const filtersWithPrefix: any = { ...filter }
  for (const key in filter) {
    if (key !== 'search') filtersWithPrefix[`${prefix}_${key}`] = filter[key]
  }
  return filtersWithPrefix
}
